import React from "react";

export const PasswordEyeIcon = props => {
  const style = {
    ...props.style
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      style={style}
    >
      <mask
        id="mask0_1473_132558"
        maskUnits="userSpaceOnUse"
        x="0"
        y="-1"
        width="24"
        height="24"
      >
        <rect y="-0.00195312" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1473_132558)">
        <path
          d="M15.2504 12.4479L14.6504 11.8479C14.8004 10.9479 14.5462 10.1854 13.8879 9.56035C13.2296 8.93535 12.4837 8.69785 11.6504 8.84785L11.0504 8.24785C11.1837 8.19785 11.3254 8.16035 11.4754 8.13535C11.6254 8.11035 11.8004 8.09785 12.0004 8.09785C12.9504 8.09785 13.7546 8.42702 14.4129 9.08535C15.0712 9.74368 15.4004 10.5479 15.4004 11.4979C15.4004 11.6979 15.3879 11.8812 15.3629 12.0479C15.3379 12.2145 15.3004 12.3479 15.2504 12.4479ZM18.4004 15.4979L17.8504 15.0479C18.4837 14.5645 19.0462 14.0354 19.5379 13.4604C20.0296 12.8854 20.4504 12.2312 20.8004 11.4979C19.9671 9.81452 18.7712 8.47702 17.2129 7.48535C15.6546 6.49368 13.9171 5.99785 12.0004 5.99785C11.5171 5.99785 11.0421 6.03118 10.5754 6.09785C10.1087 6.16452 9.65039 6.26452 9.20039 6.39785L8.65039 5.84785C9.20039 5.64785 9.75872 5.50618 10.3254 5.42285C10.8921 5.33952 11.4504 5.29785 12.0004 5.29785C14.0671 5.29785 15.9754 5.86452 17.7254 6.99785C19.4754 8.13118 20.7671 9.63118 21.6004 11.4979C21.2504 12.2479 20.8129 12.9562 20.2879 13.6229C19.7629 14.2895 19.1337 14.9145 18.4004 15.4979ZM19.7004 20.6979L15.9004 16.8979C15.5004 17.0979 14.9629 17.2812 14.2879 17.4479C13.6129 17.6145 12.8504 17.6979 12.0004 17.6979C9.91706 17.6979 8.00872 17.1312 6.27539 15.9979C4.54206 14.8645 3.25039 13.3645 2.40039 11.4979C2.80039 10.6145 3.33372 9.78535 4.00039 9.01035C4.66706 8.23535 5.36706 7.59785 6.10039 7.09785L3.30039 4.29785L3.80039 3.79785L20.2004 20.1979L19.7004 20.6979ZM6.60039 7.59785C6.00039 7.99785 5.37122 8.55202 4.71289 9.26035C4.05456 9.96868 3.55039 10.7145 3.20039 11.4979C4.03372 13.1812 5.22956 14.5187 6.78789 15.5104C8.34622 16.502 10.0837 16.9979 12.0004 16.9979C12.6504 16.9979 13.3087 16.9312 13.9754 16.7979C14.6421 16.6645 15.1171 16.5312 15.4004 16.3979L13.5504 14.5479C13.4004 14.6479 13.1671 14.7312 12.8504 14.7979C12.5337 14.8645 12.2504 14.8979 12.0004 14.8979C11.0504 14.8979 10.2462 14.5687 9.58789 13.9104C8.92956 13.252 8.60039 12.4479 8.60039 11.4979C8.60039 11.2645 8.63372 10.9937 8.70039 10.6854C8.76706 10.377 8.85039 10.1312 8.95039 9.94785L6.60039 7.59785Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};
